import {
  IS_LOADING,
  API_URL,
  GET_ERRORS,
  RESET_ANALYSIS,
  SET_ANALYSIS,
  UPDATE_CREATE_PARAMS,
  DEFAULT_PARAMS_CREATE,
} from "./types";
import axios from "axios";
import { tokenConfig } from "../utils/tokenConfig";
import SuccessAlert from "../components/Modals/SuccessAlert";

export const updateCreateParams = (key, value) => async (dispatch) => {
  dispatch({
    type: UPDATE_CREATE_PARAMS,
    payload: { key, value },
  });
};

export const getDefaultParams = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${API_URL}/params/default_params`,
      tokenConfig()
    );
    dispatch({
      type: DEFAULT_PARAMS_CREATE,
      payload: res.data,
    });
  } catch (err) {
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    dispatch({
      type: GET_ERRORS,
      payload: errors,
    });
  }
};

export const createCaso =
  (create, history, getCasesAndProjects, getDefaultParams) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_ANALYSIS,
      });
      dispatch({
        type: IS_LOADING,
      });
      var data = {
        ...create,
      };
      const body = JSON.stringify(data);
      const res = await axios.post(`${API_URL}/cases/`, body, tokenConfig());
      // set the case as "opened" in analysis
      dispatch({
        type: SET_ANALYSIS,
        payload: res.data,
      });
      // update list of cases and projects
      // reset default params
      getCasesAndProjects();
      getDefaultParams();
      dispatch({
        type: IS_LOADING,
      });
      history.push("/dashboard/cases/yourcases");
      SuccessAlert("Case created successfully");
    } catch (err) {
      dispatch({
        type: IS_LOADING,
      });
      const errors = {
        msg: err.response.data,
        status: err.response.status,
      };
      dispatch({
        type: GET_ERRORS,
        payload: errors,
      });
    }
  };
